import { Box } from "@mui/material";
import type { FC } from "react";
import { ImageLoading } from "./image-loading";

interface AiImageResultCardProps {
  id: number;
  blobUrl: string | null;
  loading: boolean;
  isSelected: boolean;
  onClick?: (url: string) => void;
}

export const AiImageResultCard: FC<AiImageResultCardProps> = ({
  id,
  blobUrl,
  loading,
  isSelected,
  onClick,
}) => {
  return (
    <Box
      data-analytics-id={`sidebar-ai-image-${id}`}
      onClick={blobUrl ? () => onClick?.(blobUrl) : undefined}
      sx={(theme) => ({
        borderRadius: 2,
        overflow: "hidden",
        backgroundColor: "background.default",
        border:
          isSelected && !loading
            ? `3px solid ${theme.palette.primary.main}`
            : `1px solid ${theme.palette.divider}`,
        aspectRatio: "3 / 4",
        position: "relative",
        cursor: blobUrl ? "pointer" : "default",
        pointerEvents: blobUrl ? "auto" : "none",
        "&:hover": {
          borderColor: blobUrl ? theme.palette.primary.light : undefined,
        },
      })}
    >
      {loading ? (
        <ImageLoading />
      ) : blobUrl ? (
        <Box
          component="img"
          src={blobUrl}
          alt=""
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : null}
    </Box>
  );
};
